<template>
  <div id="promoterRegistration">
    <Background-Image url="trees-vertical.jpg" lowResUrl="trees-vertical-lowres.jpg" color="#3E2723"></Background-Image>
    <Navigation></Navigation>
    <div class="container-fluid m-t-4 m-b-5">
      <div class="row">
        <div class="offset-md-3 col-md-6">
          <div id="PromoterRegister" class="m-t-4">
            <!--Form with header-->
            <div class="card padded">
              <div class="card-block">
                <!--Header-->
                <div class="form-header brown darken-2">
                  <h3> {{t('Login')}}</h3>
                </div>
                <!--Body-->

                <div v-if="expired" class="card card-warning text-xs-center z-depth-1 m-b-3">
                  <div class="card-block">
                    <p class="white-text">{{t('Your session has expired. Please confirm that you\'re still with us.')}}</p>
                  </div>
                </div>

                <div v-if="this.$store.state.userDeprecated.unauthorized" class="card card-danger text-xs-center z-depth-1 m-b-3">
                  <div class="card-block" v-if="this.$store.state.userDeprecated.unauthorizedStatus === 'Unauthorized'" >
                    <p class="white-text">{{t('Email/username or password don\'t match an account')}}</p>
                  </div>
                  <div class="card-block" v-if="this.$store.state.userDeprecated.unauthorizedStatus === 'Unapproved'" >
                    <p class="white-text">{{t('The Booknatura administration have not approved your account yet. If you need further assistance please contact info@booknatura.com')}}</p>
                  </div>
                  <div class="card-block" v-if="this.$store.state.userDeprecated.unauthorizedStatus === 'Unconfirmed'" >
                    <p class="white-text">{{t('You still haven\'t confirmed your account. Please check your email for confirmation instructions. If you need further assistance please contact info@booknatura.com')}}</p>
                  </div>
                </div>
                <div v-if="this.$store.state.userDeprecated.unprocessable" class="card card-warning text-xs-center z-depth-1 m-b-3 ">
                  <div class="card-block">
                    <p class="white-text">{{t('You must fill the username/email and password fields')}}</p>
                  </div>
                </div>
                <form v-on:submit.prevent="loginUser()">
                  <Text-Input :data="this.$store.state.userDeprecated.form.emailUsername"></Text-Input>
                  <Text-Input :data="this.$store.state.userDeprecated.form.password" type="password"></Text-Input>
                  <div class="text-xs-center">
                    <button v-if="!this.$store.state.userDeprecated.isUserLoggingIn" class="btn btn-success btn-lg" id="submitLoginPromoter" v-on:click="loginUser()">{{t('Login')}}</button>
                    <button v-if="this.$store.state.userDeprecated.isUserLoggingIn" class="btn btn-success btn-lg" v-on:click.prevent="loginUser()" ><i class="fa fa-circle-o-notch fa-spin"></i></button>
                  </div>
                </form>

              </div>

              <!--Footer-->
              <div class="modal-footer">
                <div class="options">
                  <p>{{t('Don\'t have an account yet?')}} <router-link v-bind:to="registerURL">{{t('Register')}}</router-link></p>
                  <p>{{t('Forgot your password?')}} <router-link v-bind:to="recoverURL">{{t('Recover')}}</router-link></p>
                  <p>{{t('Are you a supplier and don\'t have an account yet?')}} <router-link v-bind:to="promoterRegisterURL">{{t('Register as a supplier')}}</router-link></p>
                </div>
              </div>

            </div>
            <!--/Form with header-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TextInput from '../Form/V1/TextInput';
  import Navigation from '../Navigation/Navigation';
  import BackgroundImage from '../BackgroundImage';

  export default {
    name: 'UserLogin',
    components: {
      'Text-Input': TextInput,
      'Background-Image': BackgroundImage,
      Navigation,
    },
    data() {
      return {
        expired: false,
      };
    },
    computed: {
      promoterRegisterURL() {
        return `/${this.$store.state.language}/supplier/register`;
      },
      registerURL() {
        return `/${this.$store.state.language}/register`;
      },
      recoverURL() {
        return `/${this.$store.state.language}/recover`;
      },
    },
    mounted() {
      if (typeof this.$route.query.expired !== 'undefined') {
        this.expired = true;
      }
      this.$store.dispatch('UserResetUserPass');

      if (typeof this.$store.state.userDeprecated.type !== 'undefined' &&
        typeof this.$store.state.jwt !== 'undefined') {
        this.redirectUser(this.$store.state.userDeprecated);
      }
      if (this.$route.query.returnTo !== 'undefined') {
        this.$store.dispatch('setPreviousUrl', this.$route.query.returnTo);
      }
    },
    methods: {
      loginUser() {
        this.$store.dispatch('loginUser');
      },
    },
};
</script>

<style lang="scss" scoped>
  #promoterRegistration {
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?3080ad71